import {
  wordpressDevelopmentFaqs,
  wordpressSupportFaqs,
} from "../data/wordpress-services"
import { webDesignFaqs } from "../data/web-design-services"
import { webApplicationsFaqs } from "../data/web-applications-services"
import { digitalMarketingFaqs } from "../data/digital-marketing-services"
import { contentMarketingFaqs } from "../data/content-marketing-services"
import { socialMediaManagementFaqs } from "../data/social-media-services"
import {
  automationSprintFaqs,
  whiteLabelWordPressFaqs,
  wordpressFixFaqs,
} from "../data/productised-services"
import {
  chelmsfordFaqs,
  colchesterFaqs,
  southendFaqs,
} from "../data/location-services"
import { homepageFaqs } from "../data/homepage"
import { digitalMarketingTipsFaqs } from "../data/digital-marketing-tips"

const SITE_URL = "https://www.webwonderland.co.uk"
const SITE_NAME = "Web Wonderland"
const DEFAULT_IMAGE = "/img/web-design-new.jpg"
const DEFAULT_DESCRIPTION =
  "Essex web design, WordPress development and digital marketing for ambitious businesses. Fast, accessible websites and measurable digital growth."

const pages = {
  "/": {
    title: "Web Wonderland | Websites, WordPress & Digital Growth",
    description:
      "Web Wonderland helps Essex businesses grow through web design, WordPress development, digital marketing and practical automation. Call 01245 806125.",
    image: DEFAULT_IMAGE,
    faqs: homepageFaqs,
  },
  "/about/": {
    title: "About Our Essex Digital Agency",
    description:
      "Meet Web Wonderland, an Essex digital agency delivering web design, WordPress development, branding and digital marketing for businesses across the UK.",
    image: "/img/team.jpg",
    pageType: "AboutPage",
  },
  "/contact-us/": {
    title: "Contact Web Wonderland | Essex Digital Agency",
    description:
      "Talk to our Essex web design and digital marketing team about your next website, WordPress, SEO, branding or automation project. Call 01245 806125.",
    image: "/img/get-in-touch.webp",
    pageType: "ContactPage",
  },
  "/locations/": {
    title: "Areas We Support Across Essex | Web Wonderland",
    description:
      "Find local service information for Chelmsford, Southend-on-Sea and Colchester, supported by Web Wonderland's experienced Essex digital team.",
    image: DEFAULT_IMAGE,
    pageType: "CollectionPage",
  },
  "/locations/chelmsford/": {
    title: "Web Design Chelmsford | WordPress & Digital Marketing",
    description:
      "Chelmsford web design, WordPress development and digital marketing from an experienced local team. Bespoke websites, support and SEO foundations.",
    image: DEFAULT_IMAGE,
    serviceType: "Web design and WordPress development in Chelmsford",
    schemaAreaServed: [
      { "@type": "City", name: "Chelmsford" },
      { "@type": "AdministrativeArea", name: "Essex" },
    ],
    faqs: chelmsfordFaqs,
  },
  "/locations/southend-on-sea/": {
    title: "Web Design Southend-on-Sea | WordPress & SEO",
    description:
      "Southend-on-Sea web design, WordPress development and digital marketing from an experienced Essex team. Mobile-first websites, support and SEO.",
    image: DEFAULT_IMAGE,
    serviceType: "Web design and WordPress development in Southend-on-Sea",
    schemaAreaServed: [
      { "@type": "City", name: "Southend-on-Sea" },
      { "@type": "AdministrativeArea", name: "Essex" },
    ],
    faqs: southendFaqs,
  },
  "/locations/colchester/": {
    title: "Web Design Colchester | WordPress & SEO",
    description:
      "Colchester web design, WordPress development and digital marketing from an experienced Essex team. Bespoke websites, integrations, support and SEO.",
    image: DEFAULT_IMAGE,
    serviceType: "Web design and WordPress development in Colchester",
    schemaAreaServed: [
      { "@type": "City", name: "Colchester" },
      { "@type": "AdministrativeArea", name: "Essex" },
    ],
    faqs: colchesterFaqs,
  },
  "/privacy/": {
    title: "Privacy Policy",
    description:
      "How Web Wonderland collects, uses and protects information when you use our website or contact our team.",
    image: "/img/privacy.jpg",
  },
  "/working-securely/": {
    title: "Working Securely With Web Wonderland",
    description:
      "How Web Wonderland handles website access, staging, backups, source control, confidentiality, project data and technical handover.",
    image: "/img/privacy.jpg",
  },
  "/tools/manual-process-cost-calculator/": {
    title: "Manual Process Cost Calculator for UK SMEs",
    description:
      "Estimate the staff-time and rework cost of a repetitive manual process, then assess whether it may be suitable for a controlled automation sprint.",
    image: "/img/business-process-automation.jpg",
  },
  "/resources/wordpress-fix-completion-report/": {
    title: "WordPress Fix Completion Report Template",
    description:
      "A free printable template for recording what went wrong, what changed, how a WordPress fix was checked and what happens next.",
    image: "/img/wp-maintenance.jpg",
  },
  "/resources/automation-assessment-example/": {
    title: "Automation Assessment Template for SMEs",
    description:
      "A free printable template for understanding a repetitive process, its rules, human exceptions and the result your team needs.",
    image: "/img/business-process-automation.jpg",
  },
  "/resources/agency-technical-handover/": {
    title: "Agency WordPress Handover Template",
    description:
      "A free WordPress handover template for agency review, important checks, release notes and clear client-ready communication.",
    image: "/img/wp-maintenance.jpg",
  },
  "/resources/agency-wordpress-brief/": {
    title: "Agency WordPress Brief Template",
    description:
      "A practical agency template for briefing inherited WordPress, WooCommerce, integration and custom-code work clearly and securely.",
    image: "/img/wp-maintenance.jpg",
  },
  "/thank-you/wordpress-fix/": {
    title: "WordPress Fix Enquiry Received",
    description: "Confirmation that a WordPress Fix Desk enquiry was received.",
    image: "/img/wp-maintenance.jpg",
    robots: "noindex, follow",
  },
  "/thank-you/automation-sprint/": {
    title: "Automation Enquiry Received",
    description:
      "Confirmation that an SME Automation Sprint enquiry was received.",
    image: "/img/business-process-automation.jpg",
    robots: "noindex, follow",
  },
  "/thank-you/white-label-wordpress/": {
    title: "Agency Brief Received",
    description:
      "Confirmation that a white-label WordPress brief was received.",
    image: "/img/wp-maintenance.jpg",
    robots: "noindex, follow",
  },
  "/services/": {
    title: "Website, Marketing & Automation Services | Web Wonderland",
    description:
      "Compare Web Wonderland's web design, WordPress, digital marketing, branding, automation and technical support services for Essex and UK businesses.",
    image: DEFAULT_IMAGE,
  },
  "/services/web-design-development/": {
    title: "Web Design Essex | Website Design & Development",
    description:
      "Essex web design and website development for ambitious businesses. Strategy, UX, WordPress, WooCommerce and accessible websites built around enquiries.",
    image: DEFAULT_IMAGE,
    serviceType: "Web design and development in Essex",
    faqs: webDesignFaqs,
  },
  "/services/wordpress-development-essex/": {
    title: "WordPress Developer Essex | Bespoke Sites & Support",
    description:
      "Experienced WordPress developer in Essex for bespoke websites, WooCommerce, API integrations, redesigns and speed improvements, with UK-wide support.",
    image: DEFAULT_IMAGE,
    serviceType: "WordPress development",
    faqs: wordpressDevelopmentFaqs,
  },
  "/services/web-applications-cms-development/": {
    title: "Web Applications & CMS Development | Joomla & Umbraco",
    description:
      "Joomla and Umbraco development, CMS support, bespoke web applications and API integrations from Web Wonderland in Essex, working across the UK.",
    image: "/img/jamstack-maintenance.jpg",
    serviceType: "Web application and CMS development",
    schemaAreaServed: { "@type": "Country", name: "United Kingdom" },
    faqs: webApplicationsFaqs,
  },
  "/services/digital-marketing/": {
    title: "Digital Marketing Agency Essex | Strategy & Content",
    description:
      "An Essex digital marketing agency connecting strategy, SEO, content, paid campaigns, social media and conversion work around measurable customer actions.",
    image: "/img/social.jpg",
    serviceType: "Digital marketing in Essex",
    faqs: digitalMarketingFaqs,
  },
  "/services/content-marketing-essex/": {
    title: "Content Marketing Essex | Strategy, Copy & Campaigns",
    description:
      "Content marketing for Essex businesses: strategy, website copy, articles, case studies, email and campaign assets planned around a clear commercial goal.",
    image: "/img/social.jpg",
    serviceType: "Content marketing in Essex",
    faqs: contentMarketingFaqs,
  },
  "/services/social-media-management-essex/": {
    title: "Social Media Management Essex | Content & Strategy",
    description:
      "Social media management for Essex businesses, with clear content planning, copy, design, approvals, scheduling and reporting. Paid social is scoped separately.",
    image: "/img/social-1.jpg",
    serviceType: "Social media management in Essex",
    faqs: socialMediaManagementFaqs,
  },
  "/services/maintenance-support/": {
    title: "WordPress Support Essex | Fixes, Care & Performance",
    description:
      "Experienced WordPress support for Essex businesses: fixes, updates, secure hosting and performance help, with clear scopes and responsive UK support.",
    image: "/img/wp-maintenance.jpg",
    serviceType: "Website maintenance and WordPress support",
    faqs: wordpressSupportFaqs,
  },
  "/services/wordpress-fixes/": {
    title: "WordPress Fixes & Repair Services | Fixed Price",
    description:
      "WordPress problem? Get fixed-price help with broken forms, checkout issues, plugin conflicts, themes and custom code across Essex and the UK.",
    image: "/img/wp-maintenance.jpg",
    serviceType: "Fixed-price WordPress repair and troubleshooting",
    faqs: wordpressFixFaqs,
    offers: [
      { name: "Quick Fix", price: "195" },
      { name: "Complex Fix", price: "395" },
      { name: "Rescue Sprint", price: "695" },
    ],
  },
  "/services/white-label-wordpress-development/": {
    title: "White-Label WordPress Development UK | Agency Desk",
    description:
      "Need more WordPress capacity without another hire? Confidential WooCommerce, integration and overflow support for UK agencies.",
    image: "/img/wp-maintenance.jpg",
    serviceType: "White-label WordPress development for UK agencies",
    schemaAreaServed: { "@type": "Country", name: "United Kingdom" },
    faqs: whiteLabelWordPressFaqs,
    offers: [
      { name: "Technical Diagnosis", price: "275" },
      { name: "Agency Rescue Day", price: "695" },
      { name: "Two Reserved Development Days", price: "1350" },
      { name: "Five Reserved Development Days", price: "3250" },
    ],
  },
  "/services/branding-and-design/": {
    title: "Branding & Graphic Design Essex | Web Wonderland",
    description:
      "Branding and graphic design for Essex businesses, from brand strategy and visual identity to logo design, tone of voice and practical brand guidelines.",
    image: "/img/branding-design.jpg",
    serviceType: "Branding and graphic design",
  },
  "/services/business-process-automation/": {
    title: "Business Process Automation Essex | Web Wonderland",
    description:
      "Business process automation for Essex organisations. Connect systems, remove repetitive tasks and build reliable digital workflows around your team.",
    image: "/img/business-process-automation.jpg",
    serviceType: "Business process automation",
  },
  "/services/sme-automation-sprints/": {
    title: "SME Automation Services | Fixed-Price Sprints",
    description:
      "Turn one repetitive manual process into a clearer, faster workflow with fixed-price automation support for UK SMEs.",
    image: "/img/business-process-automation.jpg",
    serviceType: "Fixed-price SME workflow automation",
    faqs: automationSprintFaqs,
    offers: [
      { name: "Automation Assessment", price: "295" },
      { name: "One-Process Sprint", price: "995" },
      { name: "Connected Workflow", price: "1995" },
      { name: "Operational System", price: "2995" },
    ],
  },
  "/services/paper-print-media-buying/": {
    title: "Print & Media Buying Essex | Web Wonderland",
    description:
      "Print production, direct mail, fulfilment and media buying for Essex and London campaigns, planned as one joined-up service with your digital marketing.",
    image: "/img/ppmb-2.jpg",
    serviceType: "Print production and media buying",
  },
  "/our-work/": {
    title: "Our Work | Essex Web Design Case Studies",
    description:
      "Explore Web Wonderland case studies covering Essex web design, WordPress development, e-commerce, branding, integrations and digital transformation.",
    image: DEFAULT_IMAGE,
  },
  "/our-work/ampersand/": {
    title: "Ampersand | Social Media & Website Case Study",
    description:
      "How Web Wonderland combined a stronger website with planned social content, copy, design and publishing for Essex-based Ampersand Associates.",
    image: "/img/ampersand-2.jpg",
  },
  "/our-work/trophyman/": {
    title: "TrophyMan | Bluepark to WooCommerce Case Study",
    description:
      "How Web Wonderland migrated TrophyMan from Bluepark to WooCommerce, with 500+ products, award personalisation, bulk ordering and ongoing hosting and maintenance.",
    image: "/img/trophyman/website-showcase.webp",
  },
  "/our-work/clean-up-britain/": {
    title: "Clean Up Britain | Digital Platform Case Study",
    description:
      "How Web Wonderland modernised Clean Up Britain's digital platform to inform, inspire and involve more people in its national campaign.",
    image: "/img/cub2.jpg",
  },
  "/our-work/gtsse/": {
    title: "GTSSE | Essex Web Design & Marketing Case Study",
    description:
      "How Web Wonderland helped Essex business GTSSE establish a stronger website and a practical digital marketing presence.",
    image: "/img/gtsse-2.jpg",
  },
  "/our-work/home-legends/": {
    title: "Home Legends | Brand & Website Case Study",
    description:
      "How Web Wonderland helped turn the Home Legends business idea into a distinctive brand and digital experience.",
    image: "/img/home-legends.jpg",
  },
  "/our-work/islington-carers-hub/": {
    title: "Islington Carers Hub | Website Case Study",
    description:
      "A Web Wonderland case study for Islington Carers Hub, helping local carers find clear, accessible information and support online.",
    image: "/img/ich-2.jpg",
  },
  "/our-work/pgl/": {
    title: "PGL Travel | Multi-Brand Web Development Case Study",
    description:
      "How Web Wonderland supports PGL Travel's family holiday portfolio across multiple brands, websites and ongoing digital requirements.",
    image: "/img/pgl2.jpg",
  },
  "/our-work/rda/": {
    title: "R&D Advisors | Website & Branding Case Study",
    description:
      "A complete website, logo and branding overhaul for R&D Advisors, delivered by Web Wonderland alongside its agency partner.",
    image: "/img/rda-2.jpg",
  },
  "/our-work/savernake-knives/": {
    title: "Savernake Knives | E-commerce Case Study",
    description:
      "Web design and e-commerce work for Savernake Knives, an artisan brand crafting precision chef knives for professionals and passionate cooks.",
    image: "/img/savernake2.jpg",
  },
  "/our-work/sugar-and-rind/": {
    title: "Sugar & Rind | Events Website Case Study",
    description:
      "Website work for award-winning London events company Sugar & Rind, which creates bespoke parties for businesses and private clients across the UK.",
    image: "/img/sandr-2.jpg",
  },
  "/blog/": {
    title: "Web Design, WordPress & SEO Insights",
    description:
      "Practical web design, WordPress, SEO and digital marketing guides from Web Wonderland's Essex-based team.",
    image: DEFAULT_IMAGE,
  },
  "/blog/ai-seo-overview/": {
    title: "AI Overviews & AI Mode: What Changes for SEO",
    description:
      "A practical playbook for an AI-first search landscape: how AI Overviews and AI Mode affect SEO and how to optimise for answer engines.",
    image: "/img/blog/ai-overviews-seo.jpg",
    type: "article",
  },
  "/blog/best-website-structure-essex/": {
    title: "Best Website Structure for Essex SMEs",
    description:
      "Learn the best website structure for Essex trades, consultants and SMEs to improve local SEO, user journeys and lead generation.",
    image: "/img/blog/best-website-structure-essex.jpg",
    type: "article",
  },
  "/blog/digital-marketing-tips-essex/": {
    title: "10 Digital Marketing Tips for Essex SMEs | Web Wonderland",
    headline: "10 Digital Marketing Tips for Essex SMEs and Businesses",
    description:
      "Practical digital marketing tips for Essex SMEs: improve local SEO, website enquiries, content, social media and campaigns across Chelmsford and beyond.",
    image: "/img/blog/digital-marketing-tips-essex.webp",
    type: "article",
    datePublished: "2026-10-15",
    faqs: digitalMarketingTipsFaqs,
  },
  "/blog/digital-marketing-essex/": {
    title: "How Essex Businesses Should Choose Digital Marketing",
    headline:
      "How Should Essex Businesses Choose a Digital Marketing Approach?",
    description:
      "A practical guide to choosing digital marketing for an Essex business, connecting the website, local search, content, paid activity and measurement.",
    image: "/img/blog/digital-marketing-essex.jpg",
    type: "article",
  },
  "/blog/content-marketing-vs-social-media/": {
    title: "Content Marketing vs Social Media: What Is the Difference?",
    headline:
      "Content Marketing vs Social Media Marketing: How Should They Work Together?",
    description:
      "Understand content marketing vs social media marketing and how Essex businesses can connect articles, campaigns, social content and measurement.",
    image: "/img/blog/content-marketing-vs-social-media.webp",
    type: "article",
    datePublished: "2026-09-30",
    faqs: [
      {
        question: "Is social media part of content marketing?",
        answer:
          "Social media can distribute and adapt content marketing, but it also includes platform planning, interaction, community-management boundaries and paid activity. Treating the two as connected disciplines gives each one a clearer role.",
      },
      {
        question:
          "Should a small business start with content marketing or social media?",
        answer:
          "Start with the main commercial gap. If the website does not explain the service or answer buyer questions, strengthen the source content first. If useful material already exists but distribution is inconsistent, social media may be the immediate priority. A wider review is helpful when the whole journey is fragmented.",
      },
      {
        question:
          "Can the same content be used across every marketing channel?",
        answer:
          "The same evidence and core idea can support several channels, but the format should be adapted to the audience and context. Reuse the thinking, then adjust the hook, depth, visual treatment and next step rather than duplicating one asset everywhere.",
      },
    ],
  },
  "/blog/wordpress-redesign-seo-checklist/": {
    title: "WordPress Redesign SEO Checklist for Essex Businesses",
    headline: "WordPress Redesign SEO Checklist for Essex Businesses",
    description:
      "Planning a WordPress redesign in Essex? Check URLs, redirects, content, mobile enquiries and launch measurement before replacing your website.",
    image: "/img/blog/wordpress-redesign-seo-checklist.webp",
    type: "article",
    datePublished: "2026-09-15",
  },
  "/blog/wordpress-weekly-21-september-2026/": {
    title: "WordPress Weekly: Security Updates — 21 September 2026",
    headline:
      "WordPress Weekly: Core, WooCommerce and Security Updates — 21 September 2026",
    description:
      "WordPress security news for 21 September 2026: Core 7.1.1, WooCommerce 11.1.1, an actively exploited plugin and a hosting-layer image risk.",
    image: "/img/blog/wordpress-weekly-21-september-2026.webp",
    type: "article",
    datePublished: "2026-09-21",
  },
  "/blog/wordpress-weekly-28-september-2026/": {
    title: "WordPress 7.1.2 Security Alert | Weekly Update",
    headline:
      "WordPress Weekly: Active Core Exploitation, WooCommerce 11.1.2 and Google’s Spam Update — 28 September 2026",
    description:
      "WordPress 7.1.2 fixes an actively exploited Core flaw. Plus WooCommerce 11.1.2, Google's spam update and a practical security checklist.",
    image: "/img/blog/wordpress-weekly-28-september-2026.webp",
    type: "article",
    datePublished: "2026-09-28",
  },
  "/blog/wordpress-weekly-5-october-2026/": {
    title: "WordPress Weekly: Plugin Security & WooCommerce 11.2",
    headline:
      "WordPress Weekly: Plugin Security, WooCommerce 11.2 and Enquiry Automation — 5 October 2026",
    description:
      "Check a Contact Form 7 add-on security alert, prepare for WooCommerce 11.2 and improve enquiry follow-up with practical business automation.",
    image: "/img/blog/wordpress-weekly-5-october-2026.webp",
    type: "article",
    datePublished: "2026-10-05",
  },
  "/blog/wordpress-weekly-12-october-2026/": {
    title: "WordPress Weekly: Core Security & Checkout Fixes",
    headline:
      "WordPress Weekly: Core Security, Checkout Fixes and SME Automation — 12 October 2026",
    description:
      "Verify WordPress 7.1.3, test the WooCommerce 11.2.1 checkout hotfix and review local SEO after Google's spam update, with practical SME automation advice.",
    image: "/img/blog/wordpress-weekly-12-october-2026.webp",
    type: "article",
    datePublished: "2026-10-12",
  },
  "/blog/wordpress-weekly-19-october-2026/": {
    title: "WordPress Weekly: Plugin Security & 7.2 Testing",
    headline:
      "WordPress Weekly: Plugin Attacks, 7.2 Testing and Safer Automation — 19 October 2026",
    description:
      "Review WordPress plugin attacks, prepare for 7.2 beta testing and plan safer automation, with practical post-update SEO checks for Essex businesses.",
    image: "/img/blog/wordpress-weekly-19-october-2026.webp",
    type: "article",
    datePublished: "2026-10-19",
  },
  "/blog/secretly-santa-free-secret-santa-generator/": {
    title: "Secretly Santa: Free Secret Santa App | Web Wonderland",
    headline: "Meet Secretly Santa: Free Secret Santa, Minus the Festive Admin",
    description:
      "Meet Secretly Santa, our free gift-exchange app with private reveals, wish lists and chat. A little festive fun that shows how useful technology makes life easier.",
    image: "/img/blog/secretly-santa-free-secret-santa-generator.webp",
    type: "article",
    datePublished: "2026-10-19",
  },
  "/blog/contact-form-7-not-sending-email/": {
    title: "Contact Form 7 Not Sending Emails? WordPress Checklist",
    headline:
      "Contact Form 7 Not Sending Emails? A Practical WordPress Checklist",
    description:
      "Contact Form 7 not sending emails? Check validation, mail settings, spam filtering and integrations, with practical WordPress advice for Essex businesses.",
    image: "/img/blog/contact-form-7-not-sending-email.webp",
    type: "article",
    datePublished: "2026-09-15",
  },
  "/blog/first-business-process-to-automate/": {
    title: "What Should a Small Business Automate First?",
    headline: "What Should a Small Business Automate First? A Practical Guide",
    description:
      "Choose your first SME automation project: compare manual tasks, estimate costs and payback, plan exceptions and prepare a practical brief for your Essex business.",
    image: "/img/blog/first-business-process-to-automate.webp",
    type: "article",
    datePublished: "2026-09-15",
  },
  "/blog/white-label-wordpress-handover-checklist/": {
    title: "White-Label WordPress Handover: An Agency Checklist",
    headline: "White-Label WordPress Handover: An Agency Checklist",
    description:
      "A practical WordPress handover checklist for agencies: scope, secure access, staging, testing, backups, release approval and clear client-ready notes.",
    image: "/img/blog/white-label-wordpress-handover-checklist.webp",
    type: "article",
    datePublished: "2026-09-15",
  },
  "/blog/digital-marketing-strategy-guide/": {
    title: "How to Choose a Digital Marketing Strategy",
    description:
      "Learn how to choose the right digital marketing strategy for your SME across SEO, PPC, social media, content marketing and conversion.",
    image: "/img/blog/digital-marketing-guide.jpg",
    type: "article",
  },
  "/blog/future-web-trends-2025-and-beyond/": {
    title: "The Future of Web Design: Key Trends to Watch",
    description:
      "Explore web design trends shaping modern websites and learn how SMEs can improve UX, accessibility, mobile performance and responsible use of AI.",
    image: "/img/blog/future-web-design-2025.jpg",
    type: "article",
  },
  "/blog/inp-practical-fix-it-guide/": {
    title: "INP: A Practical Core Web Vitals Fix-It Guide",
    description:
      "A developer-first guide to improving Interaction to Next Paint by splitting long tasks, prioritising input, hydrating smarter and verifying with RUM.",
    image: "/img/blog/inp-core-web-vitals.jpg",
    type: "article",
  },
  "/blog/marketing-journey/": {
    title: "Marketing Is More Than One Touchpoint",
    description:
      "Build a joined-up marketing journey across pre-purchase, purchase and post-purchase touchpoints to create more measurable growth.",
    image: "/img/blog/marketing-journey.jpg",
    type: "article",
  },
  "/blog/meta-andromeda-complete-guide/": {
    title: "Meta Advertising Changes: The Complete Guide",
    description:
      "Understand major Meta advertising targeting changes, why costs are rising and what businesses can do to adapt and protect campaign performance.",
    image: "/img/blog/meta-andromeda.jpg",
    type: "article",
  },
  "/blog/obligary-vs-compliance-software/": {
    title: "Obligary vs UK Compliance Software",
    description:
      "Compare Obligary with UK compliance tools on SME features, pricing, evidence workflows and mobile access.",
    image: "/img/blog/obligary-vs-compliance-software.jpg",
    type: "article",
  },
  "/blog/seo-image-optimisation-guide/": {
    title: "Why Image Optimisation Matters for WordPress",
    description:
      "Learn how WordPress image optimisation improves speed, SEO, conversions and user experience, plus practical ways to make it easier.",
    image: "/img/blog/sio.jpg",
    type: "article",
  },
  "/blog/sme-website-importance/": {
    title: "Why SMEs Need a Strong Website",
    description:
      "Why a strong SME website matters for SEO, user experience, mobile visitors, trust and an effective digital marketing strategy.",
    image: "/img/blog/sme-website-2025.jpg",
    type: "article",
  },
  "/blog/visual-elements-user-experience/": {
    title: "How Visual Elements Shape User Experience",
    description:
      "How graphics, video and interactive elements influence website user experience, engagement, accessibility and conversion.",
    image: "/img/blog/visual-blog-image.jpg",
    type: "article",
  },
  "/blog/why-is-seo-important/": {
    title: "Why Is SEO Important? 10 Practical Tips",
    description:
      "Why SEO matters for business websites and ten practical ways to improve search visibility, usability and organic traffic.",
    image: "/img/blog/seo.jpg",
    type: "article",
  },
  "/blog/wordpress-api-integration/": {
    title: "WordPress API Integration: A Practical Guide",
    description:
      "A practical WordPress API integration guide with a Contact Form 7 JSON example using the WordPress HTTP API.",
    image: "/img/blog/wp-api-integration.jpg",
    type: "article",
  },
  "/blog/wordpress-development-agency/": {
    title: "Choosing a WordPress Development Agency",
    description:
      "What to look for in a WordPress development agency across UX, custom development, WooCommerce, integrations, automation and ongoing support.",
    image: "/img/blog/wordpress-development-agency.jpg",
    type: "article",
  },
  "/blog/wordpress-maintenance/": {
    title: "Why WordPress Website Maintenance Matters",
    description:
      "Why regular WordPress maintenance matters for security, speed, reliability and a better experience for website visitors.",
    image: "/img/blog/wordpress-maintenance-blog.jpg",
    type: "article",
  },
  "/blog/wordpress-speed/": {
    title: "How to Speed Up Your WordPress Website",
    description:
      "Practical ways to improve WordPress website speed, page experience and Core Web Vitals for visitors and search engines.",
    image: "/img/blog/wordpress-speed.jpg",
    type: "article",
  },
  "/seo-image-optimiser/": {
    title: "SEO Image Optimiser | WordPress Image Compression",
    description:
      "Compress WordPress images into next-generation formats and generate useful AI-assisted alt text and titles with SEO Image Optimiser.",
    image: "/img/sio-logo.jpg",
  },
  "/seo-image-optimiser-docs/": {
    title: "SEO Image Optimiser User Guide",
    description:
      "Installation, setup and usage guide for SEO Image Optimiser, including WebP and AVIF conversion, delivery modes, restore tools, AI captions and licensing.",
    image: "/img/sio-logo.jpg",
  },
  "/wwsio-privacy-policy/": {
    title: "SEO Image Optimiser Privacy Notice",
    description:
      "How SEO Image Optimiser processes images and uses optional cloud optimisation and AI captioning features.",
    image: "/img/sio-logo.jpg",
  },
  "/wwsio-terms/": {
    title: "SEO Image Optimiser Terms",
    description:
      "End User License Agreement and hosted service terms for SEO Image Optimiser, including optimisation and AI captioning features.",
    image: "/img/sio-logo.jpg",
  },
  "/404/": {
    title: "Page Not Found",
    description: "The page you requested could not be found.",
    image: "/img/get-in-touch.webp",
    robots: "noindex, follow",
  },
  "/404.html/": {
    title: "Page Not Found",
    description: "The page you requested could not be found.",
    image: "/img/get-in-touch.webp",
    robots: "noindex, follow",
  },
}

const normalisePath = pathname => {
  const path = (pathname || "/").split(/[?#]/)[0]
  const withLeadingSlash = path.startsWith("/") ? path : `/${path}`

  if (withLeadingSlash === "/") return "/"

  return `${withLeadingSlash.replace(/\/+$/, "")}/`
}

const titleFromPath = path => {
  const lastSegment = path.split("/").filter(Boolean).pop()

  if (!lastSegment) return "Essex Web Design & Digital Marketing"

  return lastSegment
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

const qualifyTitle = title => {
  const brandedTitle = `${title} | ${SITE_NAME}`

  return title.includes(SITE_NAME) || brandedTitle.length > 60
    ? title
    : brandedTitle
}

export const getPageSeo = pathname => {
  const path = normalisePath(pathname)
  const page = pages[path] || {
    title: titleFromPath(path),
    description: DEFAULT_DESCRIPTION,
    image: DEFAULT_IMAGE,
  }

  return {
    ...page,
    path,
    title: qualifyTitle(page.title),
    canonical: `${SITE_URL}${path === "/" ? "/" : path}`,
    image: page.image.startsWith("http")
      ? page.image
      : `${SITE_URL}${page.image}`,
    type: page.type || "website",
    robots: page.robots || "index, follow",
  }
}

const breadcrumbName = path => {
  if (path === "/") return "Home"
  const page = pages[path]

  if (page) return page.title.split("|")[0].trim()

  return titleFromPath(path)
}

export const buildStructuredData = seo => {
  const segments = seo.path.split("/").filter(Boolean)
  const breadcrumbItems = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: `${SITE_URL}/`,
    },
    ...segments.map((segment, index) => {
      const path = `/${segments.slice(0, index + 1).join("/")}/`

      return {
        "@type": "ListItem",
        position: index + 2,
        name: breadcrumbName(path),
        item: `${SITE_URL}${path}`,
      }
    }),
  ]

  const graph = [
    {
      "@type": ["Organization", "ProfessionalService"],
      "@id": `${SITE_URL}/#organization`,
      name: SITE_NAME,
      legalName: "Web Wonderland Ltd",
      url: `${SITE_URL}/`,
      foundingDate: "2021-09-28",
      identifier: {
        "@type": "PropertyValue",
        propertyID: "Companies House company number",
        value: "13647284",
        url: "https://find-and-update.company-information.service.gov.uk/company/13647284",
      },
      logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}/img/logo.png`,
      },
      image: `${SITE_URL}${DEFAULT_IMAGE}`,
      telephone: "+44 1245 806125",
      email: "hello@webwonderland.co.uk",
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "sales and customer enquiries",
        telephone: "+44 1245 806125",
        email: "hello@webwonderland.co.uk",
        areaServed: "GB",
        availableLanguage: "English",
      },
      priceRange: "££",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Chelmsford",
        addressRegion: "Essex",
        addressCountry: "GB",
      },
      areaServed: [
        { "@type": "AdministrativeArea", name: "Essex" },
        { "@type": "City", name: "Chelmsford" },
        { "@type": "City", name: "Colchester" },
        { "@type": "City", name: "Southend-on-Sea" },
        { "@type": "City", name: "Basildon" },
        { "@type": "City", name: "Brentwood" },
        { "@type": "Country", name: "United Kingdom" },
      ],
      sameAs: [
        "https://www.linkedin.com/company/web-wonderland-ltd",
        "https://www.facebook.com/Webwonderland/",
        "https://www.youtube.com/channel/UCWOL9qs4G2jym-Cz4OFmGEA",
      ],
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      url: `${SITE_URL}/`,
      name: SITE_NAME,
      publisher: { "@id": `${SITE_URL}/#organization` },
      inLanguage: "en-GB",
    },
    {
      "@type": seo.pageType || "WebPage",
      "@id": `${seo.canonical}#webpage`,
      url: seo.canonical,
      name: seo.title,
      description: seo.description,
      isPartOf: { "@id": `${SITE_URL}/#website` },
      about: { "@id": `${SITE_URL}/#organization` },
      breadcrumb: { "@id": `${seo.canonical}#breadcrumb` },
      primaryImageOfPage: {
        "@type": "ImageObject",
        url: seo.image,
      },
      inLanguage: "en-GB",
    },
    {
      "@type": "BreadcrumbList",
      "@id": `${seo.canonical}#breadcrumb`,
      itemListElement: breadcrumbItems,
    },
  ]

  // Only dated articles opt in; legacy posts may supply their own article schema.
  if (seo.type === "article" && seo.datePublished) {
    graph.push({
      "@type": "BlogPosting",
      "@id": `${seo.canonical}#article`,
      url: seo.canonical,
      headline: seo.headline || seo.title,
      description: seo.description,
      image: [seo.image],
      datePublished: seo.datePublished,
      mainEntityOfPage: { "@id": `${seo.canonical}#webpage` },
      author: { "@id": `${SITE_URL}/#organization` },
      publisher: { "@id": `${SITE_URL}/#organization` },
      inLanguage: "en-GB",
    })
  }

  if (seo.serviceType) {
    const service = {
      "@type": "Service",
      "@id": `${seo.canonical}#service`,
      name: seo.serviceType,
      serviceType: seo.serviceType,
      url: seo.canonical,
      provider: { "@id": `${SITE_URL}/#organization` },
      areaServed: seo.schemaAreaServed || {
        "@type": "AdministrativeArea",
        name: "Essex",
      },
    }

    if (seo.offers?.length) {
      service.hasOfferCatalog = {
        "@type": "OfferCatalog",
        name: `${seo.serviceType} packages`,
        itemListElement: seo.offers.map(offer => ({
          "@type": "Offer",
          name: offer.name,
          price: offer.price,
          priceCurrency: "GBP",
          url: seo.canonical,
        })),
      }
    }

    graph.push(service)
  }

  if (seo.faqs?.length) {
    graph.push({
      "@type": "FAQPage",
      "@id": `${seo.canonical}#faq`,
      mainEntity: seo.faqs.map(item => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      })),
    })
  }

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  }
}

export { DEFAULT_DESCRIPTION, DEFAULT_IMAGE, SITE_NAME, SITE_URL }
